const KEY = (userId) => `recordlogs_tutorial_v1_${userId}`

function load(userId) {
  try {
    const raw = localStorage.getItem(KEY(userId))
    return raw ? JSON.parse(raw) : {}
  } catch {
    return {}
  }
}

function save(userId, data) {
  try {
    localStorage.setItem(KEY(userId), JSON.stringify(data))
  } catch {}
}

export function getCompletedSteps(userId, roleId) {
  return load(userId)[roleId]?.completedSteps ?? []
}

export function toggleStep(userId, roleId, stepId) {
  const all = load(userId)
  if (!all[roleId]) all[roleId] = { completedSteps: [] }
  const steps = all[roleId].completedSteps
  const idx = steps.indexOf(stepId)
  if (idx === -1) steps.push(stepId)
  else steps.splice(idx, 1)
  all[roleId].lastOpenedAt = new Date().toISOString()
  save(userId, all)
  return [...steps]
}

export function clearRoleProgress(userId, roleId) {
  const all = load(userId)
  delete all[roleId]
  save(userId, all)
}
